export const hasCodeQualityReport = (mr) => Boolean(mr?.codequalityReportsPath);

export const hasLicenseComplianceReport = () => false;

export const hasBrowserPerformanceReport = () => false;

export const hasLoadPerformanceReport = () => false;

export const hasMetricsReport = () => false;
